import React, { useState } from "react";
import "./FifthSection.css";
import Test from "../../../assets/img/reel-section/content-fifth-section/sobre.png";
import { TapHandIcon, CreditCard } from "../../icons/SvgIcons";

export const FifthSection = () => {
  const [flipped, setFlipped] = useState(false);

  return (
    <section className="fifth-section">
      <div className="gift-title">
        <p className="gift-main-title">Sugerencia de</p>
        <p className="gift-subtitle">Regalo</p>
      </div>

      <p className="gift-description">
        Su presencia es el regalo más valioso en nuestro día tan especial, pero
        si desean hacernos uno, preferimos que sea en efectivo o transferencia.
        ¡Gracias!
      </p>

      <div
        className={`gift-card-wrapper ${flipped ? "flipped" : ""}`}
        onClick={() => setFlipped((prev) => !prev)}
      >
        <div className="gift-card">
          <div className="gift-card-front">
            <p className="gift-card-title">
              LLUVIA DE
              <br />
              SOBRES
            </p>
            <img src={Test} alt="Sobre" className="gift-card-icon" />
            <TapHandIcon className="gift-card-tap" />
          </div>

          {/* BACK */}
          <div className="gift-card-back">
            <p className="gift-card-title bank-name">BANAMEX</p>
            <p className="gift-card-number">5256 7836 0694 9098</p>
            <p className="gift-card-name">FABIÁN ENCINAS SILVAS</p>
            <CreditCard className="gift-card-credit-icon" />
            <TapHandIcon className="gift-card-tap-credit" />
          </div>
        </div>
      </div>
    </section>
  );
};
